import api from './AxiosService';

const UserService = {
  getAllUsers: (page = 1, limit = 20, search = '') => {
    let url = `/customers?page=${page}&limit=${limit}`;
    if (search) url += `&search=${search}`;
    return api.get(url);
  },
  getUserDetails: (id) => api.get(`/customers/admin/details/${id}`),
  toggleUserStatus: (id, status) => api.patch(`/customers/admin/status/${id}`, { status }),
  deleteUser: (id) => api.delete(`/customers/${id}`),
  getLeaderboard: () => api.get('/customers/leaderboard/admin'),
  getXPAnalytics: () => api.get('/customers/admin/xp-analytics'),
};

export default UserService;
